import {ChangeCredentialManager} from "./ChangeCredentialManager";
import {ApiClientInterface} from "./clients";

export class ChangePasswordManager extends ChangeCredentialManager {
  constructor(apiClient: ApiClientInterface) {
    super(apiClient);
  }

  public async changePassword(confirmationUuid: string, oldPassword: string, newPassword: string): Promise<void> {
    return this.apiClient.post("change", {confirmationUuid, oldPassword, newPassword});
  }
}